import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './First.css';
import "../App.css"

const First = () => {
  const logoContainerRef = useRef(null);
  const detailsContainerRef = useRef(null);
  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {
    const logoContainer = logoContainerRef.current;
    const detailsContainer = detailsContainerRef.current;

    // Start animations after a delay
    setTimeout(() => {
      logoContainer.classList.add('move-up');
      detailsContainer.classList.add('slide-in');
      document.body.classList.add('bg-white');

      // Slide out details container after a delay
      setTimeout(() => {
        detailsContainer.classList.add('slide-out');

        // Redirect to /home after slide-out animation
        setTimeout(() => {
          navigate('/home'); // Correctly redirect to /home
        }, 1000);
      }, 10000);
    }, 3000);
  }, [navigate]);

  return (
    <>
      <div className="logo-container" ref={logoContainerRef}>
        <img src="/assets/Grid.png" alt="Logo" className="logo" />
      </div>
      <div className="details-container" ref={detailsContainerRef}>
        <h1>Welcome to Radhika Realty</h1>
        <p>Your trusted partner in real estate.</p>
        <p>Nature’s canvas awaits, build your dream on our sprawling green plots.</p>
        <p>Transform dreams into reality on our abundant, green, and serene land.</p>
      </div>
    </>
  );
};

export default First;
